import React, { useState } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { useDispatch, useSelector } from 'react-redux'
import { patchCertificateAction } from 'src/reducers/certificate/action'
import { PatchContent, PatchData } from 'src/model/patch'
import { CoreTextField } from 'src/components/core'
const SuccessRate = props => {
  const dispatch = useDispatch()
  const { classes } = props
  const certificate = useSelector(state => state.certificate.certificate)

  const [percentage, setPercentage] = useState(
    certificate?.successRate != null ? certificate?.successRate : 0,
  )

  const handlePercentage = e => {
    //do not let the user enter more than 100
    let percentage = e
    if (e > 100) {
      percentage = 100
    }
    setPercentage(percentage)
  }

  const patchPercentage = e => {
    let percentage = e
    if (e > 100) {
      percentage = 100
    }
    const content = new PatchData(
      new PatchContent(percentage, 'successRate', PatchData.OPERATION_REPLACE),
      certificate.id,
    )
    dispatch(patchCertificateAction(content))
  }

  return (
    <div className={classes.root}>
      <Typography className={classes.heading}>
        Issue the certificate if the success rate equals or exceeds
      </Typography>
      <CoreTextField
        InputProps={{
          endAdornment: <Typography>%</Typography>,
        }}
        value={percentage}
        onChange={event => handlePercentage(event.target.value)}
        onBlur={event => patchPercentage(event.target.value)}
        className={classes.textField}
        //accepts only number
        size="small"
        type="number"
        marginTop={false}
      />
    </div>
  )
}

export default withStyles(styles)(SuccessRate)
